<div class="shrug">¯\_(ツ)_/¯</div>

<h1 class="oops">
  {{ 'ERROR.PAGE_NOT_FOUND.OOPS' | translate }}
</h1>

<p class="description">
  {{ 'ERROR.PAGE_NOT_FOUND.CANT_FIND_PAGE' | translate }}
</p>

<span class="helper-text" [innerHTML]="helperText | safe: 'html'"> </span>

<i2g-router-link
  [route]="homeRoute"
  [label]="'ERROR.PAGE_NOT_FOUND.TAKE_ME_HOME' | translate"
>
</i2g-router-link>

<app-link
  [href]="invoice2goUrl"
  [icon]="invoice2goLogo"
  [openInNewTab]="true"
  class="invoice2go-logo"
>
</app-link>
